import React from 'react';
import { CheckIcon } from 'lucide-react';
export const WebinarInfo = () => {
  const benefits = ['De complete uitleg van alle signalen', 'Praktijkvoorbeelden van échte situaties', 'Hoe je terug kunt "praten" in hondentaal', 'Wetenschappelijke onderbouwing', 'Concrete communicatietools', 'Live vraag & antwoord'];
  const WebinarLink = ({
    children
  }: {
    children: React.ReactNode;
  }) => <a href="https://stresslessdogs.nl/mcc-gpm" className="text-green-600 hover:text-green-700 hover:underline" data-id="element-125">
      {children}
    </a>;
  return <section className="w-full bg-white py-12 px-4" data-id="element-126">
      <div className="max-w-4xl mx-auto" data-id="element-127">
        <h2 className="text-2xl md:text-3xl font-bold mb-6 text-gray-800" data-id="element-128">
          100.000+ baasjes keken al de online presentatie van Amee
        </h2>
        <p className="text-lg mb-8 text-gray-700" data-id="element-129">
          Amee geeft soms een aantal keer een online presentatie (
          <WebinarLink data-id="element-130">webinar</WebinarLink>) over hondencommunicatie. Er zijn
          telkens 75 plekjes per keer en het is snel vol. Het is zelfs zo
          populair dat sinds 2024 al meer dan 100.000 mensen haar presentaties
          al hebben gekeken. Tijdens dit <WebinarLink data-id="element-131">webinar</WebinarLink> leer
          je:
        </p>
        <div className="bg-gray-50 rounded-lg p-6 mb-8" data-id="element-132">
          <ul className="space-y-4" data-id="element-133">
            {benefits.map((benefit, index) => <li key={index} className="flex" data-id="element-134">
                <div className="flex-shrink-0 mr-3" data-id="element-135">
                  <CheckIcon className="h-6 w-6 text-green-500" data-id="element-136" />
                </div>
                <p className="text-gray-700" data-id="element-137">{benefit}</p>
              </li>)}
          </ul>
        </div>
        <div className="flex justify-center mb-8" data-id="element-138">
          <a href="https://stresslessdogs.nl/mcc-gpm" className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-full transition-all duration-300 text-lg" data-id="element-139">
            BEKIJK WEBINAR PLANNING
          </a>
        </div>
        <p className="text-lg mb-8 text-gray-700" data-id="element-140">
          Het hele <WebinarLink data-id="element-141">webinar</WebinarLink> is 90 minuten. In deze 90
          minuten leer je heel anders naar honden kijken.
        </p>
        <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-lg mb-8" data-id="element-142">
          <h3 className="text-xl font-bold mb-4 text-gray-800" data-id="element-143">
            Over Amee van Stressless Dogs
          </h3>
          <div className="md:flex items-start gap-6 mb-4" data-id="element-144">
            <div className="md:w-1/3 mb-4 md:mb-0" data-id="element-145">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1sx6Hoo8q8Hjzr23JM2br4/Ontwerp_zonder_titel_%2853%29.png" alt="Amee de Bruijn met haar hond" className="rounded-lg shadow-md w-full object-cover" data-id="element-146" />
            </div>
            <div className="md:w-2/3" data-id="element-147">
              <p className="text-gray-700 mb-4" data-id="element-148">
                Amee de Bruijn is niet zomaar een hondentrainer.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-149">
                Ze is gediplomeerd hondengedragsconsultant niveau 5. Ze heeft
                meer dan 15.000 honden en baasjes geholpen met haar trainingen.
                Haar <WebinarLink data-id="element-150">webinars</WebinarLink> zijn bekeken door meer
                dan 100.000 mensen.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-151">
                Maar wat haar echt onderscheidt is haar aanpak. Ze werkt
                uitsluitend met methoden vrij van dwang, pijn, angst en straf.
                Geen dominantie. Geen correctie. Geen "je moet de baas zijn."
                Deze aanpak is totaal nieuw in Nederland en leert baasjes echt
                liefdevol samenleven met hun hond. Probleemgedrag zoals trekken
                aan de lijn, uitvallen of overmatig blaffen kan je hiermee
                zonder straffen of corrigeren stoppen en voorkomen.
              </p>
              <p className="text-gray-700" data-id="element-152">
                In hetzelfde <WebinarLink data-id="element-153">webinar</WebinarLink> legt Amee uit
                hoe dit allemaal werkt.
              </p>
            </div>
          </div>
          <div className="flex justify-center mt-6 mb-6" data-id="element-154">
            <a href="https://stresslessdogs.nl/mcc-gpm" className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-full transition-all duration-300 text-lg" data-id="element-155">
              BEKIJK WEBINAR PLANNING
            </a>
          </div>
          <div className="mt-6 flex flex-col items-center" data-id="element-156">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pEwJY2BF2TN8cavjrxYE98/Dierenwelzijn-Keurmerk.png" alt="Dierenwelzijn Keurmerk" className="h-20 object-contain mb-2" data-id="element-157" />
            <p className="text-sm text-gray-600 text-center" data-id="element-158">
              Officieel erkend door het Dierenwelzijn Keurmerk
            </p>
          </div>
        </div>
        <div className="mb-8" data-id="element-159"></div>
      </div>
    </section>;
};